import { matchPath } from 'react-router'

const patientDetailsPath = '/programs/my-physicians/:physicianId/:patientId'

export type MaOrderBackTarget =
  | { action: 'goBack' }
  | { action: 'push'; pathname: string }

export const isPatientDetailsOrigin = (from?: string): boolean =>
  !!from && matchPath(from, { path: patientDetailsPath }) !== null

/** CLOS-14588: back target for the MA order detail page. */
export const resolveMaOrderBackTarget = (from?: string): MaOrderBackTarget => {
  if (from && isPatientDetailsOrigin(from)) {
    return { action: 'push', pathname: from }
  }

  if (from === '/orders') {
    return { action: 'goBack' }
  }

  return { action: 'push', pathname: '/orders' }
}
